// store/prevPath.ts
import { atom } from 'jotai';

export const prevPathAtom = atom<string | null>(null);

export const isLoginBlockedAtom = atom<boolean | undefined>(undefined);
